import { RootState } from "../../store";

import * as authSelectors from "../auth/authSelectors";
import { VenueTag } from "../../model/VenueTag";

export const tagsForCurrentOrganization = (
  state: RootState
): VenueTag[] | null => {
  const key = authSelectors.selectedOrganizationKeyName(state);
  if (!key) {
    return null;
  }

  return state.tag.tags[key];
};
